/**
 * 화면 맨 아래 한 줄 — 무엇 위에서 도는지 밝힌다.
 *
 * 실행 엔진 Apache Airflow: 캔버스를 DAG 로 바꿔 Airflow 가 실제로 돌린다. 사용자가 실행 이력·로그를 깊게
 * 볼 때 결국 Airflow 화면을 만나게 되고, 운영자는 스케줄러·풀 같은 Airflow 개념을 알아야 한다.
 * 캔버스 React Flow: 노드·연결선 편집이 그 위에서 돈다. 조작감(휠 확대, 핸들 드래그)이 React Flow 의 것이라
 * 사용자가 검색해서 찾아볼 수 있게 이름을 밝혀 둔다.
 *
 * 둘 다 표기 의무가 있는 라이선스는 아니지만(Apache-2.0 / MIT), 밝혀 두는 편이 정직하고 문의도 줄어든다.
 * 높이를 22px 로 고정해 캔버스가 쓰는 세로 공간을 거의 빼앗지 않는다.
 */
import React from 'react';
import { IS_LOCAL } from '../../config/mode';
import { useTranslation } from 'react-i18next';
import { buildLabel } from '../../config/buildInfo';

const AppFooter: React.FC = () => {
  const { t } = useTranslation();
  return (
  <footer
    className="h-[22px] shrink-0 flex items-center justify-center gap-2 border-t border-gray-200 bg-gray-50 text-[0.6875rem] text-gray-500 select-none"
    title={t('layout:footer.title')}
  >
    <span>
      {t('layout:footer.engine')} <span className="font-medium text-gray-600">Apache Airflow</span>
    </span>
    <span className="text-gray-300">·</span>
    <span>
      {t('layout:footer.canvas')} <span className="font-medium text-gray-600">React Flow</span>
    </span>
    <span className="text-gray-300">·</span>
    <span>{IS_LOCAL ? t('layout:footer.standalone') : t('layout:footer.qbase')}</span>
    <span className="text-gray-300">·</span>
    {/* 어느 빌드인지 — 현장 문의 때 가장 먼저 묻는 것 (config/buildInfo) */}
    <span className="tabular-nums">{buildLabel()}</span>
  </footer>
  );
};

export default AppFooter;
